import React, { Fragment } from 'react';
import { LeftMenuUser } from '../LeftMenuUser';
import { CurrentUserLimits } from '../../../../slices/current-user/current-user.state';
import {
    PRACTICE_OWNER_TYPES,
    PRACTICE_STATUS_ENUM,
} from '../../../../utils/constants';
import { VenueId } from '../../../../venues/venues.types';
import { useSelectedVenueId } from '../../../../slices/venue/use-selected-venue';
import { FeatureFlag } from '../../../../containers/FeatureFlags/FeatureFlag';
import { FeatureFlagsEnum } from '../../../../containers/FeatureFlags/FeatureFlags.enum';
import { HomeMenuItem } from '../items/HomeMenuItem';
import { MyAccountMenuItem } from '../items/MyAccountMenuItem';
import { NotificationSettingsMenuItem } from '../items/NotificationSettingsMenuItem';
import { MyPracticesMenuItem } from '../items/MyPracticesMenuItem';
import { MyGroupsMenuItem } from '../items/MyGroupsMenuItem';
import { MyReferralHubMenuItem } from '../items/MyReferralHubMenuItem';
import { EcosystemHomepageMenuItem } from '../items/EcosystemHomepageMenuItem';
import { isVisibleInVenue } from '../../../../slices/venue/venue-menu-filter';
import { paths } from '../../../../routing/path';

const HEADING = 'app-sidebar__heading vertical-nav-menu';
const HEADING_CUSTOM = 'app-sidebar__heading vertical-nav-menu custom';

export interface UserMenuProps {
    user: LeftMenuUser;
    limits: CurrentUserLimits;
}

export const UserMenu = (props: UserMenuProps) => {
    const { user, limits } = props;
    const selectedVenue = useSelectedVenueId();
    const practices = user.practices || [];
    const isAnyPracticeApproved =
        practices.filter((p) => p.status === PRACTICE_STATUS_ENUM.Approved)
            .length > 0;
    const isReferral = !!user.isReferral;
    const hasReferralRequest = !!user.hasReferralRequest;
    const isFirstTimeUser = practices.length === 0 && !hasReferralRequest;
    const isFormer = user.practiceOwnerType === PRACTICE_OWNER_TYPES.FORMER;
    const charities = user.charities;

    const isReferralOrCharityReferral =
        isReferral && practices.length === 0;
    const showEcosystem =
        (isReferralOrCharityReferral && !charities) ||
        (charities ? charities.length < 1 : false);

    return (
        <Fragment>
            <div id="left-menu" />
            <div>
                <div>
                    {!isReferralOrCharityReferral && (
                        <HomeMenuItem
                            className={
                                isAnyPracticeApproved ||
                                isReferral ||
                                isFirstTimeUser
                                    ? HEADING
                                    : HEADING_CUSTOM
                            }
                        />
                    )}
                    <MyAccountMenuItem />
                    <FeatureFlag flag={FeatureFlagsEnum.FF_Notifications}>
                        {(isAnyPracticeApproved || isReferral) && (
                            <NotificationSettingsMenuItem />
                        )}
                    </FeatureFlag>
                    {!isFirstTimeUser && (
                        <Fragment>
                            {!hasReferralRequest && !isReferral && isVisibleInVenue([VenueId.Grow], selectedVenue) && (
                                <MyPracticesMenuItem
                                    practices={practices}
                                    headingClassName={HEADING}
                                />
                            )}
                            {isFormer && isVisibleInVenue([VenueId.Grow], selectedVenue) && (
                                <MyGroupsMenuItem
                                    summary={user}
                                    limits={limits}
                                    headingClassName={HEADING_CUSTOM}
                                    headingTo={paths.venues.grow.myGroups}
                                />
                            )}
                            {isVisibleInVenue([VenueId.Share], selectedVenue) && (
                                <MyReferralHubMenuItem
                                    isReferralPartner={isReferral}
                                    withFlag={false}
                                    className={
                                        isAnyPracticeApproved || isReferral
                                            ? HEADING
                                            : HEADING_CUSTOM
                                    }
                                />
                            )}
                        </Fragment>
                    )}
                </div>
            </div>

            {showEcosystem && <EcosystemHomepageMenuItem />}
        </Fragment>
    );
};
